export default __webpack_public_path__ + "static/media/UTAP_AppIcon.5aea77f1.png";